import React, {useEffect, useState} from 'react';
import Translate, {t} from "../../../../../../../../components/Translate";
import BlueButton from "../../../../../../../../components-new/buttons/BlueButton";
import DropdownSelect from "../../../../../../../../components-new/form/DropdownSelect";
import {getTemplates} from "../../../../../../../../services/company/api";
import ImportIcon from "../../../../../../../../assets/icons/ImportIcon";

function ImportTemplates({clients, onImport, user}) {

    const [selectedClientId, setSelectedClientId] = useState('');
    const [selectedFolderName, setSelectedFolderName] = useState('');
    const [folders, setFolders] = useState([]);
    const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        if (!selectedClientId) return;
        setIsFetching(true);
        getTemplates(selectedClientId).then((data) => {
            const clientFolders = []

            data.forEach((item) => {
                if (item.folderName && item.folderName !== '...' && !clientFolders.some(folder => folder === item.folderName)) {
                    clientFolders.push(item.folderName);
                }
            })

            setFolders(clientFolders);
        }).finally(() => setIsFetching(false));
    }, [selectedClientId]);

    return (
        <div className="stg-add-row">

            <DropdownSelect
                renderLabel={val => val ? val.label : <Translate text={'selectBot'}/>}
                selectedValue={clients.map((c) => ({
                    value: c.id,
                    label: c.name
                })).find(c => c.value === selectedClientId)}
                options={clients.map((c) => ({value: c.id, label: c.name}))}
                onChange={(e) => setSelectedClientId(e.value)}
                direction={'top'}
                disabled={isFetching}
                itemStyles={{
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    width: '100%'
                }}
            />

            <DropdownSelect
                renderLabel={val => val ? val : <Translate text={'allFolders'}/>}
                selectedValue={selectedFolderName}
                options={folders}
                onChange={(e) => setSelectedFolderName(e)}
                direction={'top'}
                disabled={folders.length === 0 || isFetching}
                itemStyles={{
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    width: '100%'
                }}
            />


            <BlueButton
                size="md"
                width={'150px'}
                onClick={() => {
                    onImport(selectedClientId, selectedFolderName || null)
                    setSelectedFolderName('')
                }}
                disabled={!selectedClientId}
            >
                <ImportIcon strokeWidth={2} width={16} height={16}/>
                <Translate text={"import"}/>
            </BlueButton>
        </div>
    );
}

export default ImportTemplates;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/resources/templates/ImportTemplates.jsx